import { useEffect } from 'react';
import { useAnalytics } from './useAnalytics';

export type Feature =
  | 'painel'
  | 'clientes'
  | 'ordens'
  | 'recorrencias'
  | 'dashboard'
  | 'equipe'
  | 'servicos';

// Module-scope Set — persists across component unmount/remount in the same page load.
// Cleared on hard reload (new module instance) and on logout (via resetFeatureTracking).
const fired = new Set<Feature>();

/**
 * Clears the session dedup Set. Called on logout (AuthContext) and from tests
 * to reset state between assertions.
 */
export function resetFeatureTracking() {
  fired.clear();
}

export function useFeatureTracking(feature: Feature) {
  const { track } = useAnalytics();

  useEffect(() => {
    if (fired.has(feature)) return;
    fired.add(feature);
    track('feature_used', { feature });
  }, [feature, track]);
}
